

//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'

// 共用
// import { List as SocketContent } from '../spot/websocket/index'
import { Data as BasicContent } from '../spot/api/basic/index'

import { Data as TradeOrderContent } from './api/trade/index'
import Introduce from './1_introduce.json'

import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "常見問題",
  "content": QandAContent
}


const ROOT_MODULE = "zh-tw/standard"

// export const Socket = {
//   "module": ROOT_MODULE,
//   "path": `/${ROOT_MODULE}/socket`,
//   "name": "Socket 文檔",
//   "children": SocketContent
// }


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "變更日誌",
  "content": ChangeLogContent
}
const TradeOrder = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/contract-interface.html`,
  "name": "標准合約接口",
  "content": TradeOrderContent
}
const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "簽名認證",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "基礎信息",
  "content": BasicContent
}


export const standardConfig = [
  Introduce,
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  TradeOrder,
  // Socket,
]


// WEBPACK FOOTER //
// ./src/config/zh-tw/standard/index.js